import { memo } from "react";
import { t } from "components/CentralDataMangement/translation/Translation";
import type { SelectedFileState, Filters } from "./Interface";
import Button from "components/common/atoms/Button";
import ResetBtn from "components/common/atoms/ResetBtn";
import TextEllipsis from "components/common/atoms/TextEllipsis";
import InputTextfield from "components/common/atoms/InputTextField";
import SelectWithSearch from "components/common/atoms/SelectWithSearch";

interface LogViewerHeaderProps {
  file: SelectedFileState;
  filters: Filters;
  viewMode: "table" | "raw" | "json";
  onFilterChange: (key: keyof Filters, value: string | number) => void;
  onRefresh: () => void;
  setViewMode: (mode: "table" | "raw" | "json") => void;
}

const LogViewerHeader = memo(
  ({
    file,
    filters,
    viewMode,
    onFilterChange,
    onRefresh,
    setViewMode,
  }: LogViewerHeaderProps) => {
    // Options for log level dropdown
    const logLevelOptions = [
      { value: "all", label: "All Levels" },
      { value: "ERROR", label: "Error" },
      { value: "WARN", label: "Warning" },
      { value: "INFO", label: "Info" },
      { value: "DEBUG", label: "Debug" },
    ];

    // Options for view mode dropdown
    const viewModeOptions = [
      { value: "table", label: "Table" },
      { value: "raw", label: "Raw" },
      { value: "json", label: "JSON" },
    ];

    // Handle log level change
    const handleLogLevelChange = (selectedOption: any) => {
      onFilterChange("logLevel", selectedOption?.value || "all");
    };

    // Handle view mode change
    const handleViewModeChange = (selectedOption: any) => {
      setViewMode(selectedOption?.value || "table");
    };

    // Get current selected values
    const selectedLogLevel = logLevelOptions.find(
      (option) => option.value === filters.logLevel
    );
    const selectedViewMode = viewModeOptions.find(
      (option) => option.value === viewMode
    );

    return (
      <div className="card-header log-detailed-header">
        <div className="d-flex align-items-center justify-content-between">
          <span className="color-dark-pink fw-bold">{file.name}</span>
          <div className="d-flex">
            <div className="d-flex marginRightPoint5">
              <div className="marginRightPoint5 hideHeight hideLabel">
                <SelectWithSearch
                  search={false}
                  options={logLevelOptions}
                  value={selectedLogLevel}
                  onChange={handleLogLevelChange}
                  placeHolder="Select Level"
                  name="logLevel"
                  className="form-select-sm"
                  isSelectOption={false}
                  style={{ minHeight: "32px" }}
                  isTranslate={false}
                />
              </div>
              <div className="hideHeight hideLabel">
                <SelectWithSearch
                  search={false}
                  options={viewModeOptions}
                  value={selectedViewMode}
                  onChange={handleViewModeChange}
                  placeHolder="Select View"
                  name="viewMode"
                  className="form-select-sm"
                  isSelectOption={false}
                  style={{ minHeight: "32px" }}
                  isTranslate={false}
                />
              </div>
            </div>
            <div className="d-flex align-items-center justify-content-between">
              <InputTextfield
                placeholder={t("Search logs")}
                value={filters.searchTerm}
                handleChange={(e) =>
                  onFilterChange("searchTerm", e.target.value)
                }
                className="marginRightPoint5 form-control field-shadow"
              />
              <ResetBtn handleResetClick={onRefresh} />
            </div>
          </div>
        </div>
      </div>
    );
  }
);

LogViewerHeader.displayName = "LogViewerHeader";

export default LogViewerHeader;
